(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["vendors"] = factory(require("jQuery"));
	else
		root["vendors"] = factory(root["jQuery"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__786__) => {
return 